import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { settingsItemSx, StyledSwitch } from 'framework/ui/layout';
import useJournalEntriesSettings from 'domain/finance/journalEntry/shared/Settings/useJournalEntriesSettings';
import { useListContext } from 'framework/list';

const JournalEntryStornoToggler = () => {
  const { setStornedJournalEntriesVisible, areStornedJournalEntriesVisible } = useJournalEntriesSettings();
  const { loading } = useListContext();

  const onChangeCallback = (event: any) => {
    setStornedJournalEntriesVisible(event.target.checked);
  };

  return (
    <FormControlLabel
      sx={settingsItemSx}
      control={
        <StyledSwitch
          color="primary"
          onChange={onChangeCallback}
          checked={areStornedJournalEntriesVisible}
          dataOn="ON"
          dataOff="OFF"
          disabled={loading}
        />
      }
      label="Show storned entries"
    />
  );
};

export default JournalEntryStornoToggler;
